/* VetPro site-wide search overlay — native Shopify predictive search (/search/suggest.json).
   Grouped results (Products / Ingredients / Articles / Pages), opens on click, "/" and Cmd/Ctrl-K.
   Self-contained; markup + styles are rendered by the header section. v5. */
(function () {
  'use strict';
  var overlay, input, resultsEl, statusEl, items = [], active = -1, seq = 0, debounce;

  function init() {
    overlay = document.getElementById('vp-search');
    if (!overlay) return;
    input = overlay.querySelector('[data-vp-search-input]');
    resultsEl = overlay.querySelector('[data-vp-search-results]');
    statusEl = overlay.querySelector('[data-vp-search-status]');

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-vp-search-open]');
      if (t) { e.preventDefault(); open(); }
      if (e.target === overlay || e.target.closest('[data-vp-search-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      var mod = e.metaKey || e.ctrlKey;
      if (mod && (e.key === 'k' || e.key === 'K')) { e.preventDefault(); open(); return; }
      if (e.key === '/' && !isTyping(e.target) && !isOpen()) { e.preventDefault(); open(); return; }
      if (!isOpen()) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter') { var a = items[active]; if (a) window.location.href = a.href; }
    });

    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (!q) { render(null); return; }
      debounce = setTimeout(function () { query(q); }, 160);
    });
  }

  function isOpen() { return overlay && overlay.getAttribute('aria-hidden') === 'false'; }
  function isTyping(el) { return el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable); }

  // Keep Tab inside the overlay while it's open, and hand focus back to whatever opened it.
  var releaseTrap = null;
  function open() {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 30);
    if (window.VPFocusTrap && !releaseTrap) releaseTrap = window.VPFocusTrap.trap(overlay);
  }
  function close() {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
  }

  function move(dir) {
    if (!items.length) return;
    if (active > -1) items[active].el.classList.remove('is-active');
    active = (active + dir + items.length) % items.length;
    items[active].el.classList.add('is-active');
    items[active].el.scrollIntoView({ block: 'nearest' });
  }

  function query(q) {
    var mine = ++seq;
    statusEl.textContent = 'Searching…';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,page,article&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (mine === seq) render(data.resources.results, q); })
      .catch(function () { if (mine === seq) statusEl.textContent = 'Search is unavailable right now.'; });
  }

  function render(res, q) {
    items = []; active = -1; resultsEl.innerHTML = '';
    if (!res) { statusEl.textContent = 'Type to search products, ingredients, articles and pages.'; return; }

    var products = (res.products || []).filter(notPreview);
    var pages = (res.pages || []).filter(notPreview);
    var articles = (res.articles || []).filter(notPreview);
    var ingredients = [], otherPages = [];
    pages.forEach(function (p) {
      (/\/pages\/ingredient-/.test(p.url) ? ingredients : otherPages).push(p);
    });

    var groups = [
      { label: 'Products', rows: products.map(function (p) {
          return row(p.title, p.url, p.featured_image && p.featured_image.url, money(p.price), 'Product'); }) },
      { label: 'Ingredients', rows: ingredients.map(function (p) {
          return row(p.title, p.url, null, 'Ingredient glossary', 'Ingredient'); }) },
      { label: 'Articles', rows: articles.map(function (a) {
          return row(a.title, a.url, a.image, 'Learn', 'Article'); }) },
      { label: 'Pages', rows: otherPages.map(function (p) {
          return row(p.title, p.url, null, '', 'Page'); }) }
    ];

    var total = 0;
    groups.forEach(function (g) {
      if (!g.rows.length) return;
      total += g.rows.length;
      var h = document.createElement('p'); h.className = 'vp-search__group'; h.textContent = g.label;
      resultsEl.appendChild(h);
      g.rows.forEach(function (r) { resultsEl.appendChild(r); });
    });

    if (!total) {
      statusEl.textContent = 'No matches for “' + q + '”.';
    } else {
      statusEl.textContent = '';
      if (items[0]) { active = 0; items[0].el.classList.add('is-active'); }
    }
  }

  function notPreview(x) { return !/^\s*\[preview\]/i.test(x.title || ''); }

  function row(title, href, img, meta, badge) {
    var a = document.createElement('a');
    a.className = 'vp-search__row'; a.href = href;
    if (!img) a.classList.add('vp-search__row--nothumb');
    a.innerHTML =
      (img ? '<img class="vp-search__thumb" src="' + img + '" alt="" width="40" height="40" loading="lazy">' : '') +
      '<span class="vp-search__meta"><span class="vp-search__title"></span>' +
      (meta ? '<span class="vp-search__sub"></span>' : '') + '</span>' +
      '<span class="vp-search__badge">' + badge + '</span>';
    a.querySelector('.vp-search__title').textContent = title;
    if (meta) a.querySelector('.vp-search__sub').textContent = meta;
    a.addEventListener('mouseenter', function () {
      if (active > -1 && items[active]) items[active].el.classList.remove('is-active');
      active = items.findIndex(function (x) { return x.el === a; });
      a.classList.add('is-active');
    });
    items.push({ el: a, href: href });
    return a;
  }

  function money(cents) {
    if (cents == null) return '';
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
